import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
type Testimonial = {
  text: string;
  name: string;
  business: string;
};
const testimonials: Testimonial[] = [{
  text: 'Antes nadie nos encontraba en internet. Ahora recibimos pedidos por WhatsApp todos los días gracias a nuestra página web. NovaWeb cumplió todo lo que prometió.',
  name: 'Carlos Mendoza',
  business: 'Restaurante El Sabor'
}, {
  text: 'Mi barbería se ve ahora más profesional que la competencia. Los clientes llegan diciendo que encontraron mi página y eso no pasaba antes.',
  name: 'Andrés Peña',
  business: 'Barbería Kings'
}, {
  text: 'Mis pacientes agendan citas desde la página web. NovaWeb entregó rápido, con calidad y sin complicaciones. 100% recomendado.',
  name: 'Dra. María Torres',
  business: 'Clínica Sonrisa Perfecta'
}];
export function Testimonials() {
  return <section id="testimonios" className="bg-[#0a0a1e] relative overflow-hidden" style={{
    padding: '80px 20px'
  }} data-id="element-495">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-496">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-497">
          <h2 className="text-white font-bold text-center" style={{
          fontSize: '2.5rem',
          lineHeight: 1.2
        }} data-id="element-498">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <div className="w-16 h-[3px] bg-[#00d4ff] mx-auto mt-4 mb-4" data-id="element-499" />
          <p className="text-lg max-w-2xl mx-auto" style={{
          color: 'rgba(255,255,255,0.6)'
        }} data-id="element-500">
            Negocios reales que ya confían en NovaWeb
          </p>
        </motion.div>

        <div className="grid gap-6" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        alignItems: 'stretch'
      }} data-id="element-501">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex flex-col" style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(0, 212, 255, 0.2)',
          borderRadius: '16px',
          padding: '32px'
        }} data-id="element-502">
              <div className="flex items-center gap-1 mb-4" data-id="element-503">
                {[0, 1, 2, 3, 4].map(s => <Star key={s} size={18} fill="#00d4ff" strokeWidth={0} color="#00d4ff" data-id="element-504" />)}
              </div>
              <p className="text-base leading-relaxed mb-6 flex-grow" style={{
            color: 'rgba(255,255,255,0.85)'
          }} data-id="element-505">
                “{t.text}”
              </p>
              <div className="mt-auto" data-id="element-506">
                <p className="text-white font-bold" data-id="element-507">{t.name}</p>
                <p className="text-sm" style={{
              color: '#00d4ff'
            }} data-id="element-508">
                  {t.business}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}